// import http from './src/http';
import { iconUrls } from '@dap/config';
// import { clearPending,postJson,putJson,deleteJson } from './src/http';
import authMixin from './src/mixins/auth/authMixin'
// import helperRoutes from './src/routers';

export const loadIconfonts = () => {
    iconUrls.forEach((url) => {
        const oScript = document.createElement('script');
        oScript.type = 'text/javascript';
        oScript.src = `https:${url}`;
        document.body.appendChild(oScript);
    });
};

export {
    // clearPending,
    // postJson,
    // putJson,
    // deleteJson,
    // http,
    authMixin,
    // helperRoutes,
};

